import { useState, useEffect, useCallback } from 'react';
import PageHeader from '../../components/ui/PageHeader';
import Modal from '../../components/ui/Modal';
import toast from 'react-hot-toast';
import api from '../../services/api';

const TODOS_MODULOS = [
  'dashboard','chat','crm','clientes','contratos',
  'midias','trafego','chamados','projetos','reunioes','financeiro','admin',
];

const MODULO_LABEL = {
  dashboard:  'Dashboard',
  chat:       'Chat',
  crm:        'CRM / Pipeline',
  clientes:   'Clientes',
  contratos:  'Contratos',
  midias:     'Mídias Sociais',
  trafego:    'Tráfego Pago',
  chamados:   'Chamados',
  projetos:   'Projetos',
  reunioes:   'Reuniões',
  financeiro: 'Financeiro',
  admin:      'Administração',
};

const NIVEL_LABEL = { 1: 'Administrador', 2: 'Gerencial', 3: 'Operacional' };
const NIVEL_COR   = { 1: '#A78BFA', 2: '#38BDF8', 3: '#94A3B8' };
const NIVEL_BG    = { 1: 'rgba(167,139,250,.12)', 2: 'rgba(56,189,248,.12)', 3: 'rgba(148,163,184,.1)' };

const MODULOS_RESTRITOS = ['contratos', 'financeiro', 'crm', 'admin'];

function Badge({ children, cor, bg }) {
  return (
    <span style={{ fontSize: 10, fontWeight: 700, color: cor, background: bg, padding: '3px 8px', borderRadius: 999 }}>
      {children}
    </span>
  );
}

function Avatar({ nome, size = 32 }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '28%', background: '#6C4CF5',
      color: '#fff', fontWeight: 700, fontSize: size * 0.4,
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      {nome?.charAt(0) || '?'}
    </div>
  );
}

// ── FORM NOVO COLABORADOR ─────────────────────────────────────────────────────

function FormNovoColaborador({ onSalvar, onFechar }) {
  const [f, setF] = useState({ nome: '', email: '', username: '', cargo: '', nivel_acesso: 3 });
  const s = (k, v) => setF(p => ({ ...p, [k]: v }));
  return (
    <form onSubmit={e => { e.preventDefault(); onSalvar(f); }} className="space-y-4">
      <div><label className="form-label">Nome completo *</label><input className="form-input" value={f.nome} onChange={e => s('nome', e.target.value)} required /></div>
      <div><label className="form-label">E-mail *</label><input type="email" className="form-input" value={f.email} onChange={e => s('email', e.target.value)} required /></div>
      <div>
        <label className="form-label">Usuário de acesso</label>
        <input className="form-input" value={f.username} onChange={e => s('username', e.target.value.replace(/\s/g, ''))}
          placeholder="Vazio = primeiro nome (ex.: Julio)" autoCapitalize="none" />
      </div>
      <div><label className="form-label">Cargo</label><input className="form-input" value={f.cargo} onChange={e => s('cargo', e.target.value)} placeholder="Ex: Designer, Filmmaker..." /></div>
      <div>
        <label className="form-label">Nível de acesso</label>
        <select className="form-input" value={f.nivel_acesso} onChange={e => s('nivel_acesso', parseInt(e.target.value))}>
          <option value={2}>Nível 2 — Gerencial</option>
          <option value={3}>Nível 3 — Operacional</option>
        </select>
      </div>
      <div style={{ padding: '10px 14px', background: 'rgba(56,189,248,.08)', border: '1px solid rgba(56,189,248,.2)', borderRadius: 10, fontSize: 12, color: '#38BDF8' }}>
        A senha provisória é <strong>123mudar</strong>. No primeiro acesso, o colaborador é obrigado a criar uma senha própria.
      </div>
      <div className="flex gap-2">
        <button type="submit" className="btn-primary flex-1">Criar Colaborador</button>
        <button type="button" onClick={onFechar} className="btn-secondary">Cancelar</button>
      </div>
    </form>
  );
}

// ── MODAL EDITAR COLABORADOR ──────────────────────────────────────────────────

function ModalEditar({ usuario, isSelf, onSalvar, onSalvarPerms, onFechar }) {
  const [aba, setAba] = useState('dados');
  const [f, setF] = useState({
    nome:     usuario.nome     || '',
    email:    usuario.email    || '',
    username: usuario.username || '',
    cargo:    usuario.cargo    || '',
    telefone: usuario.telefone || '',
    bio:      usuario.bio      || '',
    senha:    '',
  });
  const [modulos, setModulos] = useState(usuario.modulos || []);
  const [nivel, setNivel]     = useState(usuario.nivel_acesso);
  const [showSenha, setShowSenha] = useState(false);
  const s = (k, v) => setF(p => ({ ...p, [k]: v }));

  const mudarNivel = (n) => {
    setNivel(n);
    if (n === 1) setModulos(TODOS_MODULOS);
    else if (n === 2) setModulos(['dashboard','chat','midias','trafego','chamados','reunioes']);
    else setModulos(['dashboard','chat','chamados','reunioes']);
  };

  const toggleModulo = (m) => {
    if (m === 'dashboard') return;
    setModulos(prev => prev.includes(m) ? prev.filter(x => x !== m) : [...prev, m]);
  };

  const salvarDados = (e) => {
    e.preventDefault();
    const dados = { nome: f.nome, email: f.email, cargo: f.cargo, telefone: f.telefone, bio: f.bio };
    if (f.username && f.username !== usuario.username) dados.username = f.username;
    if (f.senha) dados.senha = f.senha;
    onSalvar(dados);
  };

  const salvarAcesso = () => {
    onSalvarPerms(nivel, modulos);
  };

  return (
    <div>
      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid #2A3652' }}>
        {[{ k: 'dados', l: 'Dados pessoais' }, { k: 'acesso', l: 'Acesso & Módulos', disabled: isSelf }].map(t => (
          <button key={t.k} onClick={() => !t.disabled && setAba(t.k)} style={{
            padding: '7px 16px', fontSize: 13, background: 'none', border: 'none', cursor: t.disabled ? 'not-allowed' : 'pointer',
            color: aba === t.k ? '#6C4CF5' : t.disabled ? '#3d4f72' : '#94A3B8',
            fontWeight: aba === t.k ? 700 : 400,
            borderBottom: aba === t.k ? '2px solid #6C4CF5' : '2px solid transparent',
            marginBottom: -1, opacity: t.disabled ? 0.4 : 1,
          }}>{t.l}</button>
        ))}
      </div>

      {aba === 'dados' && (
        <form onSubmit={salvarDados} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="col-span-2">
              <label className="form-label">Nome completo *</label>
              <input className="form-input" value={f.nome} onChange={e => s('nome', e.target.value)} required />
            </div>
            <div>
              <label className="form-label">Usuário de acesso</label>
              <input className="form-input" value={f.username} onChange={e => s('username', e.target.value.replace(/\s/g, ''))} autoCapitalize="none" />
            </div>
            <div>
              <label className="form-label">E-mail</label>
              <input type="email" className="form-input" value={f.email} onChange={e => s('email', e.target.value)} />
            </div>
            <div>
              <label className="form-label">Cargo</label>
              <input className="form-input" value={f.cargo} onChange={e => s('cargo', e.target.value)} placeholder="Ex: Designer, Filmmaker..." />
            </div>
            <div>
              <label className="form-label">Telefone / WhatsApp</label>
              <input className="form-input" value={f.telefone} onChange={e => s('telefone', e.target.value)} placeholder="(81) 9 9999-9999" />
            </div>
            <div style={{ position: 'relative' }}>
              <label className="form-label">Nova senha</label>
              <input
                type={showSenha ? 'text' : 'password'}
                className="form-input"
                value={f.senha}
                onChange={e => s('senha', e.target.value)}
                placeholder="Vazio = não alterar (será provisória)"
                style={{ paddingRight: 36 }}
              />
              <button type="button" onClick={() => setShowSenha(v => !v)} style={{ position: 'absolute', right: 10, top: 34, background: 'none', border: 'none', cursor: 'pointer', color: '#64748B' }}>
                {showSenha ? '🙈' : '👁️'}
              </button>
            </div>
            <div className="col-span-2">
              <label className="form-label">Bio</label>
              <textarea className="form-input" rows={2} value={f.bio} onChange={e => s('bio', e.target.value)} placeholder="Uma frase sobre o colaborador..." />
            </div>
          </div>
          <div className="flex gap-2 pt-2 border-t border-gray-100">
            <button type="submit" className="btn-primary flex-1">Salvar dados</button>
            <button type="button" onClick={onFechar} className="btn-secondary">Cancelar</button>
          </div>
        </form>
      )}

      {aba === 'acesso' && (
        <div className="space-y-5">
          {/* Nível */}
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10 }}>Nível de acesso</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
              {[
                { v: 1, l: 'Administrador', desc: 'Acesso total' },
                { v: 2, l: 'Gerencial',     desc: 'Módulos selecionados' },
                { v: 3, l: 'Operacional',   desc: 'Acesso restrito' },
              ].map(n => (
                <button key={n.v} type="button" onClick={() => mudarNivel(n.v)} style={{
                  padding: '10px 8px', borderRadius: 10, textAlign: 'left', border: 'none', cursor: 'pointer', transition: 'all .15s',
                  background: nivel === n.v ? NIVEL_BG[n.v] : 'rgba(255,255,255,.03)',
                  outline: nivel === n.v ? `2px solid ${NIVEL_COR[n.v]}50` : '2px solid transparent',
                }}>
                  <p style={{ fontSize: 12, fontWeight: 700, color: nivel === n.v ? NIVEL_COR[n.v] : '#94A3B8' }}>{n.l}</p>
                  <p style={{ fontSize: 10, color: '#64748B', marginTop: 2 }}>{n.desc}</p>
                </button>
              ))}
            </div>
          </div>

          {/* Módulos */}
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10 }}>Módulos com acesso</p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 6 }}>
              {TODOS_MODULOS.map(m => {
                const ativo = modulos.includes(m);
                const fixo  = m === 'dashboard';
                const restrito = MODULOS_RESTRITOS.includes(m);
                return (
                  <label key={m} style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px', borderRadius: 10, cursor: fixo ? 'not-allowed' : 'pointer',
                    background: ativo ? 'rgba(108,76,245,.1)' : 'rgba(255,255,255,.03)',
                    border: `1px solid ${ativo ? 'rgba(108,76,245,.3)' : '#2A3652'}`,
                    opacity: fixo ? 0.6 : 1, transition: 'all .15s',
                  }}>
                    <input type="checkbox" checked={ativo} disabled={fixo} onChange={() => toggleModulo(m)} style={{ accentColor: '#6C4CF5', width: 14, height: 14 }} />
                    <span style={{ fontSize: 12, fontWeight: 500, color: ativo ? '#E2E8F4' : '#64748B', flex: 1 }}>{MODULO_LABEL[m]}</span>
                    {restrito && <span style={{ fontSize: 9, color: '#F87171', background: 'rgba(248,113,113,.1)', padding: '1px 5px', borderRadius: 4, fontWeight: 700 }}>RESTRITO</span>}
                    {fixo && <span style={{ fontSize: 9, color: '#64748B' }}>sempre</span>}
                  </label>
                );
              })}
            </div>
          </div>

          <div className="flex gap-2 pt-2 border-t border-gray-100">
            <button type="button" onClick={salvarAcesso} className="btn-primary flex-1">Salvar acesso</button>
            <button type="button" onClick={onFechar} className="btn-secondary">Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── COMPONENTE PRINCIPAL ──────────────────────────────────────────────────────

export default function Admin() {
  const [eu, setEu]             = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [modalNovo, setModalNovo] = useState(false);
  const [editando, setEditando]   = useState(null);

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get('/usuarios');
      setUsuarios(data || []);
    } catch { toast.error('Erro ao carregar colaboradores.'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    api.get('/auth/me').then(r => setEu(r.data)).catch(() => {});
    carregar();
  }, [carregar]);

  const isAdmin = eu?.nivel_acesso <= 1;

  const criarColaborador = async (dados) => {
    try {
      await api.post('/usuarios', { ...dados, nivel_acesso: parseInt(dados.nivel_acesso) });
      toast.success('Colaborador criado!');
      setModalNovo(false);
      carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao criar.'); }
  };

  const salvarDados = async (dados) => {
    try {
      await api.patch(`/usuarios/${editando.id}`, dados);
      toast.success('Dados salvos!');
      setEditando(null);
      carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro.'); }
  };

  const salvarPerms = async (nivel_acesso, modulos) => {
    try {
      await api.patch(`/usuarios/${editando.id}`, { nivel_acesso });
      await api.put(`/usuarios/${editando.id}/permissoes`, { modulos });
      toast.success('Permissões salvas!');
      setEditando(null);
      carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro.'); }
  };

  const toggleAtivo = async (u) => {
    try {
      await api.patch(`/usuarios/${u.id}`, { ativo: !u.ativo });
      toast(u.ativo ? 'Colaborador desativado.' : 'Colaborador ativado!');
      carregar();
    } catch { toast.error('Erro.'); }
  };

  const excluirColaborador = async (u) => {
    if (!window.confirm(`Tem certeza que deseja EXCLUIR "${u.nome}"? Esta ação não pode ser desfeita.`)) return;
    try {
      await api.delete(`/usuarios/${u.id}`);
      toast.success(`${u.nome} excluído.`);
      carregar();
    } catch (err) { toast.error(err.response?.data?.error || 'Erro ao excluir.'); }
  };

  const fmtData = d => d ? new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}><p style={{ color: '#64748B' }}>Carregando...</p></div>;

  return (
    <div>
      <PageHeader
        title="Administração"
        subtitle="Colaboradores e níveis de acesso"
        actions={isAdmin && <button onClick={() => setModalNovo(true)} className="btn-primary">+ Novo Colaborador</button>}
      />

      {!isAdmin && (
        <div style={{ padding: '12px 16px', background: 'rgba(251,191,36,.08)', border: '1px solid rgba(251,191,36,.25)', borderRadius: 12, marginBottom: 20, fontSize: 13, color: '#FBBF24' }}>
          🔒 Você está em modo somente leitura. Apenas o Administrador pode alterar permissões.
        </div>
      )}

      {/* Tabela */}
      <div style={{ background: '#19243A', border: '1px solid #2A3652', borderRadius: 14, overflow: 'hidden', marginBottom: 24 }}>
        <div className="resp-table-wrap" style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse', minWidth: 700 }}>
            <thead>
              <tr style={{ background: 'rgba(255,255,255,.02)', borderBottom: '1px solid #2A3652' }}>
                {['Colaborador','Cargo','E-mail / Telefone','Nível','Módulos','Último acesso','Status',''].map((h, i) => (
                  <th key={i} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {usuarios.map(u => {
                const modulos = u.modulos || [];
                return (
                  <tr key={u.id} style={{ borderBottom: '1px solid rgba(42,54,82,.5)' }}>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <Avatar nome={u.nome} size={34} />
                        <div>
                          <p style={{ fontSize: 13, fontWeight: 600, color: '#E2E8F4' }}>{u.nome}</p>
                          {u.bio && <p style={{ fontSize: 11, color: '#64748B', maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.bio}</p>}
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: '12px 16px', color: '#94A3B8', fontSize: 12 }}>{u.cargo || '—'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ fontSize: 12, color: '#64748B' }}>
                        {u.username && <p style={{ color: '#A5B4FC', fontWeight: 600 }}>@{u.username}{u.deve_trocar_senha ? ' · senha provisória' : ''}</p>}
                        {u.email    && <p>{u.email}</p>}
                        {u.telefone && <p>{u.telefone}</p>}
                        {!u.email && !u.telefone && <p>—</p>}
                      </div>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <Badge cor={NIVEL_COR[u.nivel_acesso]} bg={NIVEL_BG[u.nivel_acesso]}>{NIVEL_LABEL[u.nivel_acesso]}</Badge>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, maxWidth: 180 }}>
                        {modulos.filter(m => m !== 'conta').slice(0, 4).map(m => (
                          <span key={m} style={{ fontSize: 10, color: '#94A3B8', background: 'rgba(255,255,255,.06)', padding: '2px 6px', borderRadius: 5 }}>{MODULO_LABEL[m] || m}</span>
                        ))}
                        {modulos.filter(m => m !== 'conta').length > 4 && (
                          <span style={{ fontSize: 10, color: '#6C4CF5', background: 'rgba(108,76,245,.12)', padding: '2px 6px', borderRadius: 5, fontWeight: 700 }}>+{modulos.filter(m => m !== 'conta').length - 4}</span>
                        )}
                      </div>
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 11, color: '#64748B', whiteSpace: 'nowrap' }}>{fmtData(u.ultimo_login)}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ fontSize: 10, fontWeight: 700, color: u.ativo ? '#4ADE80' : '#64748B', background: u.ativo ? 'rgba(74,222,128,.12)' : 'rgba(148,163,184,.1)', padding: '3px 8px', borderRadius: 999 }}>{u.ativo ? 'Ativo' : 'Inativo'}</span>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', gap: 10, whiteSpace: 'nowrap' }}>
                        {isAdmin && (
                          <button onClick={() => setEditando(u)} style={{ fontSize: 12, color: '#6C4CF5', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Editar</button>
                        )}
                        {isAdmin && u.id !== eu?.id && (
                          <button onClick={() => toggleAtivo(u)} style={{ fontSize: 12, color: u.ativo ? '#F87171' : '#4ADE80', background: 'none', border: 'none', cursor: 'pointer' }}>
                            {u.ativo ? 'Desativar' : 'Ativar'}
                          </button>
                        )}
                        {isAdmin && u.id !== eu?.id && (
                          <button onClick={() => excluirColaborador(u)} style={{ fontSize: 12, color: '#EF4444', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                            Excluir
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Legenda de níveis */}
      <div className="resp-grid-3" style={{ gap: 12 }}>
        {[
          { nivel: 1, desc: 'Acesso total. Gerencia colaboradores, permissões, contratos, CRM e financeiro.' },
          { nivel: 2, desc: 'Acesso às áreas da sua gestão. Pode ser configurado para módulos específicos.' },
          { nivel: 3, desc: 'Acesso operacional limitado às tarefas atribuídas pelo administrador.' },
        ].map(n => (
          <div key={n.nivel} style={{ background: '#19243A', border: '1px solid #2A3652', borderRadius: 12, padding: '14px 16px' }}>
            <div style={{ marginBottom: 6 }}>
              <Badge cor={NIVEL_COR[n.nivel]} bg={NIVEL_BG[n.nivel]}>Nível {n.nivel} — {NIVEL_LABEL[n.nivel]}</Badge>
            </div>
            <p style={{ fontSize: 12, color: '#64748B', lineHeight: 1.5 }}>{n.desc}</p>
          </div>
        ))}
      </div>

      {/* Modal novo */}
      <Modal open={modalNovo} onClose={() => setModalNovo(false)} title="Novo Colaborador" size="md">
        <FormNovoColaborador onSalvar={criarColaborador} onFechar={() => setModalNovo(false)} />
      </Modal>

      {/* Modal editar */}
      <Modal open={!!editando} onClose={() => setEditando(null)} title={`Editar — ${editando?.nome}`} size="lg">
        {editando && (
          <ModalEditar
            usuario={editando}
            isSelf={editando.id === eu?.id}
            onSalvar={salvarDados}
            onSalvarPerms={salvarPerms}
            onFechar={() => setEditando(null)}
          />
        )}
      </Modal>
    </div>
  );
}
